import * as React from 'react';
import { Price } from '@grandvisionhq/common';
import { Heading, Text } from '@grandvisionhq/elements';

const OrderLineItemsSummary = ({ labels , prices , currency  })=>/*#__PURE__*/ React.createElement("div", {
        className: "order-line-items-summary"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "order-line-items-summary__content"
    }, /*#__PURE__*/ React.createElement(Heading, {
        className: "order-line-items-summary__heading",
        variant: "subheading1"
    }, labels.summaryLabel), /*#__PURE__*/ React.createElement("div", {
        className: "order-line-items-summary__totals"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "order-line-items-summary__totals--row"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "order-line-items-summary__totals--label"
    }, /*#__PURE__*/ React.createElement(Text, {
        component: "span"
    }, labels.subtotal)), /*#__PURE__*/ React.createElement("div", {
        className: "order-line-items-summary__totals--value"
    }, /*#__PURE__*/ React.createElement(Price, {
        value: prices.subtotal,
        currency: currency
    }))), prices.totalDiscount > 0 && /*#__PURE__*/ React.createElement("div", {
        className: "order-line-items-summary__totals--row"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "order-line-items-summary__totals--label"
    }, /*#__PURE__*/ React.createElement(Text, {
        component: "span"
    }, labels.totalDiscount)), /*#__PURE__*/ React.createElement("div", {
        className: "order-line-items-summary__totals--value "
    }, /*#__PURE__*/ React.createElement(Price, {
        className: "order-line-items-summary__totals--discount",
        value: prices.totalDiscount,
        currency: currency,
        type: "discount"
    }))), /*#__PURE__*/ React.createElement("div", {
        className: "order-line-items-summary__totals--row"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "order-line-items-summary__totals--label"
    }, /*#__PURE__*/ React.createElement(Text, {
        component: "span"
    }, labels.delivery)), /*#__PURE__*/ React.createElement("div", {
        className: "order-line-items-summary__totals--value"
    }, prices.delivery > 0 ? /*#__PURE__*/ React.createElement(Price, {
        value: prices.delivery,
        currency: currency
    }) : /*#__PURE__*/ React.createElement(Text, {
        component: "span"
    }, labels.freeDelivery))), prices.paymentMethodPrice > 0 ? /*#__PURE__*/ React.createElement("div", {
        className: "order-line-items-summary__totals--row"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "order-line-items-summary__totals--label"
    }, /*#__PURE__*/ React.createElement(Text, {
        component: "span"
    }, labels.paymentMethod)), /*#__PURE__*/ React.createElement("div", {
        className: "order-line-items-summary__totals--value"
    }, /*#__PURE__*/ React.createElement(Price, {
        value: prices.paymentMethodPrice,
        currency: currency
    }))) : null, /*#__PURE__*/ React.createElement("div", {
        className: "order-line-items-summary__totals--row"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "order-line-items-summary__totals--label"
    }, /*#__PURE__*/ React.createElement(Heading, {
        className: "order-line-items-summary__totals--heading",
        variant: "subheading1"
    }, labels.total)), /*#__PURE__*/ React.createElement("div", {
        className: "order-line-items-summary__totals--value"
    }, /*#__PURE__*/ React.createElement(Price, {
        className: "order-line-items-summary__totals--final",
        value: prices.total,
        currency: currency
    }))))))
;

export { OrderLineItemsSummary };
//# sourceMappingURL=OrderLineItemsSummary.js.map
